module.exports = __webpack_public_path__ + "static/media/launch.20a87f14.svg";